import { some, every } from 'lodash';

function email(value) {
    let tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/; //eslint-disable-line no-useless-escape

    if (!value)
        return false;

    if (value.length > 254)
        return false;

    var valid = tester.test(value);
    if (!valid)
        return false;

    // Further checking of some things regex can't handle
    var parts = value.split("@");
    if (parts[0].length > 64)
        return false;

    var domainParts = parts[1].split(".");
    if (domainParts.some(function (part) { return part.length > 63; }))
        return false;

    return true;
}

function password(value) {
    let score = 0;

    if (!value)
        return false;

    if (value.length >= 8 && value.length <= 60)
        score++;

    if (/[A-Z]/.test(value)) //eslint-disable-line no-useless-escape
        score++;

    if (/[0-9]/.test(value)) //eslint-disable-line no-useless-escape
        score++;

    if (true) //eslint-disable-line no-useless-escape
        score++;

    return score;
}


/**
 * Comprueba si el usuario posee rol de SUPERADMIN
 * 
 * @param {Array} roles 
 */
 function userIsSuperadmin(roles) {
	let superadminRoles = [
		'ROLE_SUPERADMIN',
	]

	return some(roles, (x) =>
		superadminRoles.includes(x)
	);
}


/**
 * Comprueba si el usuario posee algún rol de administrador
 * 
 * @param {Array} roles 
 */
function userIsAdmin(roles) {
	let adminRoles = [
		'ROLE_ADMIN',
		'ROLE_SUPERADMIN',
	]

	return some(roles, (x) =>
		adminRoles.includes(x)
	);
}

/**
 * Comprueba si el usuario posee algún rol de AGD
 * 
 * @param {Array} roles 
 */
function userIsAGD(roles) {
	let agdRoles = [
		'ROLE_USER',
		'ROLE_ADMIN',
		'ROLE_SUPERADMIN',
	]

	return some(roles, (x) =>
		agdRoles.includes(x)
	);
}

/**
 * Comprueba si el usuario posee algún rol de DISA (Centro Comercial)
 * 
 * @param {Array} roles 
 */
function userIsDisa(roles) {
	let disaRoles = [
		'ROLE_DISA_ADMIN',
		'ROLE_DISA_USER',
	]

	return some(roles, (x) =>
		disaRoles.includes(x)
	);
}

/**
 * Comprueba si el usuario posee rol de DISA Admin (Centro Comercial)
 * 
 * @param {Array} roles 
 */
function userIsDisaAdmin(roles) {
	let disaAdminRoles = [
		'ROLE_ADMIN',
		'ROLE_DISA_USER',
	]
    let disaAdmin = every(roles, (x) =>
        disaAdminRoles.includes(x)
	);

    let disaSuperAdminRoles = [
		'ROLE_DISA_ADMIN',
	]
    let disaSuperAdmin = some(roles, (x) =>
        disaSuperAdminRoles.includes(x)
    );

    return disaAdmin || disaSuperAdmin;
}



export default {
    email,
    password,
    userIsSuperadmin,
    userIsAdmin,
    userIsAGD,
    userIsDisa,
    userIsDisaAdmin
}


// WEBPACK FOOTER //
// ./src/utils/Validations.js